// components/Seo.js
import Head from "next/head";
import { useRouter } from "next/router";
export default function Seo({ meta = {}, noIndex = false }) {
  const router = useRouter();
  const {
    meta_title = "Royalsmartlifestyle - Tour & Travel",
    meta_description = "Experience luxury and convenience with RoyalSmartLimousine. Your premier choice for limousine services, travel, and lifestyle solutions.",
    meta_keywords = "limousine, luxury, travel, lifestyle",
    canonical
  } = meta;
  const baseUrl = "https://www.royalsmartlimousine.com";


  const canonicalUrl =
    canonical || `${baseUrl}${router.asPath.split("?")[0]}`;
  return (
    <Head>
      <title>{meta_title}</title>
      <meta name="description" content={meta_description} />
      <meta name="keywords" content={meta_keywords} />

      <meta
        name="robots"
        content={noIndex ? "noindex, follow" : "index, follow"}
      />
      <link rel="canonical" href={canonicalUrl} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Royal Smart Limousine",
            "alternateName": "RSL",
            "url": "https://www.royalsmartlimousine.com",
            "logo": "https://www.royalsmartlimousine.com/img/general/logo-dark_rsl.svg",
            "sameAs": [
              "https://www.facebook.com/royalsmartlimousine",
              "https://twitter.com/SmartLimousine",
              "https://www.instagram.com/rsl.uae/",
              "https://www.royalsmartlimousine.com"
            ]
          })
        }}
      />
    </Head>
  );
}
